/**
 * Masks a CPF (Brazilian tax ID) to show only the last 2 digits
 * Example: 123.456.789-01 -> XXX.XXX.XXX-01
 */
export function maskCPF(cpf: string | null | undefined): string {
  if (!cpf) return "Não informado";
  
  // Remove all non-numeric characters
  const cleanCPF = cpf.replace(/\D/g, "");
  
  if (cleanCPF.length !== 11) return cpf; // Return original if invalid format
  
  // Show only last 2 digits
  const lastTwo = cleanCPF.slice(-2);
  return `XXX.XXX.XXX-${lastTwo}`;
}

/**
 * Masks a phone number to show only the last 4 digits
 * Example: (11) 98765-4321 -> (XX) XXXXX-4321
 */
export function maskPhone(phone: string | null | undefined): string {
  if (!phone) return "Não informado";
  
  // Remove all non-numeric characters
  const cleanPhone = phone.replace(/\D/g, "");
  
  if (cleanPhone.length < 4) return phone; // Return original if too short
  
  // Show only last 4 digits
  const lastFour = cleanPhone.slice(-4);
  
  // Format based on length (10 or 11 digits)
  if (cleanPhone.length === 11) {
    return `(XX) XXXXX-${lastFour}`;
  } else if (cleanPhone.length === 10) {
    return `(XX) XXXX-${lastFour}`;
  }
  
  return `XXXXX-${lastFour}`;
}
